module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"上一篇":"Previous","下一篇":"Next"},"zh":{"上一篇":"上一篇","下一篇":"下一篇"}}')
  delete Component.options._Ctor
}
